import axios from 'axios';
import { Banner } from './admin-banners.type';
import { logFunction, sectionCreateConfig, sectionDeleteConfig, sectionEditConfig } from '../../services/logs';

export const createBanner = async (serviceUrl: string, banner: Banner) => {
    const { id, ...payload } = banner;
    const res = await logFunction({
        config: {
            ...sectionCreateConfig,
            description: 'Создание баннера'
        },
        wrapperFunction() {
            return axios.post(`${serviceUrl}`, payload);
        },
        body: payload,
    });
    const created = { id: res.data._id, ...res.data.data };
    return created as Banner;
};

export const updateBanner = async (serviceUrl: string, banner: Banner) => {
    const { id, ...payload } = banner;
    const res = await logFunction({
        config: {
            ...sectionEditConfig,
            description: 'Обновление баннера'
        },
        wrapperFunction() {
            return axios.put(`${serviceUrl}`, payload, { params: { id } });
        },
        body: banner,
    })
    const updated = { id: res.data._id, ...res.data.data };
    return updated as Banner;
};

export const deleteBanner = async (serviceUrl: string, id: string) => {
    await logFunction({
        config: {
            ...sectionDeleteConfig,
            description: 'Удаление баннера',
        },
        wrapperFunction() {
            return axios.delete(`${serviceUrl}`, { params: { id } });
        }
    });
};
